// Generated by scripts/build-ui-icons.mjs.
export { User as default } from "../ui/glyphs-7";
